import Nullstack from 'nullstack';
export default function IconDisabledOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-disabled-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M11 7a2 2 0 1 0 -2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M11 11v4h4l4 5"
  }), "   ", Nullstack.element("path", {
    d: "M15 11h1"
  }), "   ", Nullstack.element("path", {
    d: "M7 11.5a5 5 0 1 0 6 7.5"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}